import { render, staticRenderFns } from "./BasicNameList.vue?vue&type=template&id=b938af72&"
import script from "./BasicNameList.vue?vue&type=script&lang=js&"
export * from "./BasicNameList.vue?vue&type=script&lang=js&"
import style0 from "./BasicNameList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports